import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import NoPic from "../../Assets/Images/emptypic.png"
import {useNavigate} from "react-router-dom";
import {FaUserEdit} from "react-icons/fa";
import {IoMdHelpBuoy} from "react-icons/io";
import {BsChevronCompactLeft, BsInfoCircleFill} from "react-icons/bs";
import {GoSignIn, GoSignOut} from "react-icons/go";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Loading from "../../Layouts/Loading";
import {MdRuleFolder} from "react-icons/md";


export default function Profile() {
    const navigate = useNavigate();


    const [user , setUser] = React.useState([]);
    const [hasToken , setHasToken] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(true);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            setHasToken(true)
            setIsLoaded(false);

            API.getUserInfo()
                .then((response) => {
                    setIsLoaded(true);
                    setUser(response.data.user);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    return (
        <React.Fragment>

            <Header title='حساب من' hasBack={false} />
            {
                !isLoaded && <Loading />
            }
            <main className="container-fluid mt-3 pt-5">
                <div className="row px-3 ">
                    <div className="col-12 rtl profile-header" >
                        <div className="card-body pt-4">
                            <div className="row pb-4" >
                                <div className="col-3">
                                    <img src={user.avatar ? user.avatar : NoPic } className="rounded-circle mx-auto d-block" alt={user.first_name} width="50px" height="50px"/>
                                </div>
                                <div className="col-9">
                                    {
                                        hasToken? <div className=" fw-bold pt-2">{user.name} {user.surname}</div>
                                            :
                                            <div className=" fw-bold pt-2">کاربر میهمان</div>
                                    }

                                    <span className=" super-small-2 ltr">
                                            {user.username ? user.username.replace('+98' , '0') : ''}
                                        </span>
                                    {
                                        hasToken &&
                                            <div className="profile-edit-user"
                                                 onClick={()=>navigate('/edit-profile')}
                                            >
                                                ویرایش
                                                &nbsp;
                                                <FaUserEdit className='text-big'/>
                                            </div>
                                    }
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <div className="container-fluid profile-list-items">
                    {
                        !hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item " onClick={() => navigate('/login')}>

                            <div className="col-1">
                                <GoSignIn className="text-success"/>
                            </div>
                            <div className="col-10  menu-text text-success">
                               وارد شوید
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/contents/درباره-ما')} >

                        <div className="col-1">
                            <BsInfoCircleFill className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            درباره  نیروگستران
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/contents/قوانین')} >

                        <div className="col-1">
                            <MdRuleFolder className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                             قوانین و مقررات
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/contents/تماس-پشتیبانی')} >

                        <div className="col-1">
                            <IoMdHelpBuoy className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            تماس با پشتیبانی
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    {
                        hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0" onClick={onExitClick}>

                            <div className="col-1">
                                <GoSignOut className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                خروج از حساب کاربری
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    <div className='row mt-4'>
                        <div className="col-12 text-center text-small-3 fw-bold opacity-50">
                            <a className='text-muted opacity-25 text-decoration-none' rel="noreferrer" href="https://idmt.ir/" target='_blank'>
                            Powered By IDeS
                            </a>
                        </div>
                    </div>
                </div>

            </main>
            <Navbar  />
        </React.Fragment>
    );

}

